<template>
    <Session :id="$route.params.id" @close="$router.push({ path: '/payments' })" />
</template>

<script>
import Session from "@/components/shared/Session";

export default {
    components: { Session },
};
</script>